import { AccountType, Employee, Position, PositionType } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@mui/material';
import { PoolButton, PoolModal } from '@synergy/components';
import { useState } from 'react';

import { CustomerEmployeeAutocomplete } from '../../customer/customer-detail/employees/components/customer-empoyee-autocomplete';
import { PoolPositionAutocompleteList } from '../../../../common/components/autocomplete-list/position-autocomplete-list/pool-position-autocomplete-list';
import { SupplierEmployeeAutocomplete } from '../../supplier/supplier-detail/employees/components/supplier-empoyee-autocomplete';

export interface AddEmployeeModalProps {
    isVisible: boolean;
    organizationId?: number;
    employeeType: AccountType;
    onConfirm: (employee: Employee) => void;
    onCancel: () => void;
}

export const AddEmployeeModal = (props: AddEmployeeModalProps) => {
    const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(null);
    const [position, setPosition] = useState<Position | undefined>(undefined);

    const { isVisible, organizationId, employeeType, onConfirm, onCancel } = props;

    const handleConfirm = () => {
        if (selectedEmployee) {
            onConfirm({ ...selectedEmployee, position });
        }
        setPosition(undefined);
    };

    const handleCancel = () => {
        setPosition(undefined);
        onCancel();
    };

    if (!organizationId) {
        return null;
    }

    return (
        <PoolModal
            title={<FormattedMessage id="app.contactsAndOrganizations.detail.addPerson" />}
            isVisible={isVisible}
            actionChildren={[
                <PoolButton key="1" variant="text" styleType="firstLevel" onClick={handleCancel}>
                    <FormattedMessage id="app.common.cancel" />
                </PoolButton>,
                <PoolButton key="2" styleType="firstLevel" onClick={handleConfirm} disabled={!selectedEmployee}>
                    <FormattedMessage id="app.common.add" />
                </PoolButton>,
            ]}
            handleClose={handleCancel}
        >
            <Grid container={true} spacing={2}>
                <Grid item={true} xs={12}>
                    {employeeType === 'customer' ? (
                        <CustomerEmployeeAutocomplete
                            accountId={organizationId}
                            onSelected={setSelectedEmployee}
                            disablePreventOverflow={true}
                        />
                    ) : (
                        <SupplierEmployeeAutocomplete
                            accountId={organizationId}
                            onSelected={setSelectedEmployee}
                            disablePreventOverflow={true}
                        />
                    )}
                </Grid>
                <Grid item={true} xs={12}>
                    <PoolPositionAutocompleteList
                        types={[
                            PositionType.All,
                            employeeType === AccountType.Customer ? PositionType.Customer : PositionType.Supplier,
                        ]}
                        label={<FormattedMessage id="app.header.position" />}
                        onSelected={position => setPosition(position ?? undefined)}
                        disablePreventOverflow={true}
                    />
                </Grid>
            </Grid>
        </PoolModal>
    );
};
